<template lang="html">
    <div id="loadCharge" class="loaderPoints" v-if="active">
        <div class="h-100 w-100 position-relative d-flex justify-content-center align-items-center align-content-center">
            <img :src="logo" class="mbLogo">
            <img :src="a13" class="spinner">
        </div>
    </div>
</template>
<script>
export default {
    name:"loaderAnim",
    props:{
        active:{
            default: false,
            type: Boolean
        }
    },
    data(){
        return{
            a13:require('@/assets/images/a13.png'),
            logo:require('@/assets/images/franchise/logo.jpg'),
        }
    }
}
</script>
<style lang="css" scoped>
#loadCharge.loaderPoints{
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: all;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    z-index: 9999;
    animation: fade 1s forwards;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.3);
}

#loadCharge.loaderPoints .mbLogo{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    object-fit: cover;
    position: absolute;
    margin: auto;
    animation: palp 1s linear infinite;
    pointer-events: none;
}
#loadCharge.loaderPoints .spinner{
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    animation: charge 1s linear infinite;
    pointer-events: none;
}

</style>
